import { render, staticRenderFns } from "./BuyNew.vue?vue&type=template&id=6947cc33&scoped=true"
import script from "./BuyNew.vue?vue&type=script&lang=js"
export * from "./BuyNew.vue?vue&type=script&lang=js"
import style0 from "./BuyNew.vue?vue&type=style&index=0&id=6947cc33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6947cc33",
  null
  
)

export default component.exports